import { useCallback, useRef } from 'react';
import type { Request } from './Collaboration';
import type { Mutation } from './dashboardModel';

export const root = '/api/governance/dashboards';
export class DashboardApiError extends Error { constructor(public status: number, message: string) { super(message); } }
export async function read<T>(request: Request, url: string, init?: RequestInit): Promise<T> {
  const response = await request(url, init);
  if (!response.ok) {
    const body = await response.json().catch(() => null);
    throw new DashboardApiError(response.status, body?.error?.message ?? (response.status === 401 ? 'Connectez-vous pour ouvrir cet espace personnel.' : response.status === 404 ? 'Ce tableau ou ce lien est indisponible, expiré ou hors de vos droits.' : response.status === 403 ? 'Vous ne disposez pas des droits nécessaires.' : response.status === 409 ? 'Une modification concurrente a été détectée. Votre travail local est conservé.' : `Opération impossible (${response.status}).`));
  }
  return response.json() as Promise<T>;
}
export function useCommands(request: Request) {
  const pending = useRef(new Map<string, string>());
  return useCallback(async (path: string, payload: object = {}) => {
    const key = path + JSON.stringify(payload); const commandId = pending.current.get(key) ?? crypto.randomUUID(); pending.current.set(key, commandId);
    const result = await read<Mutation>(request, root + path, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ ...payload, commandId }) });
    pending.current.delete(key); return result;
  }, [request]);
}
